var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 45,
    viewBox: "0 0 43 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.8033 0.387695L27.6111 4.62423L34.7999 4.61054L37.0084 11.4518L42.8322 15.6661L40.5978 22.4988L42.8322 29.3315L37.0084 33.5458L34.7999 40.387L27.6111 40.3734L21.8033 44.6099L15.9955 40.3734L8.80675 40.387L6.59829 33.5458L0.774414 29.3315L3.00889 22.4988L0.774414 15.6661L6.59829 11.4518L8.80675 4.61054L15.9955 4.62423L21.8033 0.387695Z",
    fill: "#2F88FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.0625 22.4992L19.5903 28.027L30.6458 16.9714",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessMessage);
export default __webpack_public_path__ + "static/media/success-message.f7717d68418f3db7d02260702c7a05c2.svg";
export { ForwardRef as ReactComponent };